import { Rating, Stack, Typography } from '@mui/material';

const GameRating = ({ value, onChange, readOnly = false }) => {
  const ratingValue = Number(value) || 0;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Rating
        size="small"
        value={ratingValue}
        max={5}
        readOnly={readOnly}
        onChange={(_, nextValue) => onChange?.(nextValue || null)}
      />
      {ratingValue > 0 ? (
        <Typography variant="body2" color="text.secondary">
          {ratingValue}/5
        </Typography>
      ) : null}
    </Stack>
  );
};

export default GameRating;
